import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    '&.MuiTable-root': {
      marginTop: 24,
    },
  },
  pagination: {
    '&.MuiPagination-root': {
      marginTop: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
}));

export default useStyles;
